(function () {

    // Strict
    'use strict';

    // Factory
    angular.module('app').factory('db.factory', ['$window', '$q', '$indexedDB', function ($window, $q, $indexedDB) {
        return {
            logs: {
                add: function (log) {
                    return $indexedDB.openStore('Logs', function (store) {
                        return store.insert(log);
                    });
                },
                all: function () {
                    return $indexedDB.openStore('Logs', function (store) {
                        return store.getAll();
                    });
                },
                clear: function () {
                    return $indexedDB.openStore('Logs', function (store) {
                        return store.clear();
                    });
                }
            },
            geometries: {
                upsertGeometries: function (geometries) {
                    return $indexedDB.openStore('Geometries', function (store) {
                        var promiseA = store.getAllKeys();
                        var promiseB = promiseA.then(function (keys) {
                            var queryPromises = [];
                            var keysToDelete = [];
                            for (var i = 0; i < keys.length; i++) {
                                var key = keys[i];
                                var deferred = $q.defer();
                                queryPromises.push(deferred.promise);
                                var extra = function (k, d, find) {
                                    find.then(function (dbObject) {
                                        for (var j = 0; j < geometries.length; j++) {
                                            if (dbObject.Handle == geometries[j].Handle) {
                                                keysToDelete.push(k);
                                                break;
                                            }
                                        }
                                        d.resolve();
                                    });
                                };
                                extra(key, deferred, store.find(key));
                            }
                            //console.log(queryPromises);
                            return $q.all(queryPromises).then(function () {
                                return keysToDelete;
                            });
                        });
                        var promiseC = promiseB.then(function (keys) {
                            var deletePromises = [];
                            for (var i = 0; i < keys.length; i++) {
                                deletePromises.push(store.delete(keys[i]));
                            }
                            return $q.all(deletePromises);
                        });
                        var promiseD = promiseC.then(function () {
                            var upsertPromises = [];
                            for (var i = 0; i < geometries.length; i++) {
                                upsertPromises.push(store.upsert(geometries[i], geometries[i].Handle));
                            }
                            return $q.all(upsertPromises);
                        });
                        return promiseD;
                    })
                },
                upsert: function (geometry) {
                    return $indexedDB.openStore('Geometries', function (store) {
                        return store.upsert(geometry);
                    });
                },
                add: function (geometries) {
                    return $indexedDB.openStore('Geometries', function (store) {
                        return store.insert(geometries);
                    });
                },
                remove: function (key) {
                    return $indexedDB.openStore('Geometries', function (store) {
                        return store.delete(key);
                    });
                },
                get: function (key) {
                    return $indexedDB.openStore('Geometries', function (store) {
                        return store.find(key);
                    });
                },
                all: function () {
                    return $indexedDB.openStore('Geometries', function (store) {
                        return store.getAll();
                    });
                },
                clear: function () {
                    return $indexedDB.openStore('Geometries', function (store) {
                        return store.clear();
                    });
                }
            },
            tasks: {
                upsert: function (tasks) {
                    return $indexedDB.openStore('Tasks', function (store) {
                        return store.upsert(tasks);
                    });
                },
                add: function (tasks) {
                    return $indexedDB.openStore('Tasks', function (store) {
                        return store.insert(tasks);
                    });
                },
                remove: function (key) {
                    return $indexedDB.openStore('Tasks', function (store) {
                        return store.delete(key);
                    });
                },
                get: function (key) {
                    return $indexedDB.openStore('Tasks', function (store) {
                        return store.find(key);
                    });
                },
                all: function () {
                    return $indexedDB.openStore('Tasks', function (store) {
                        return store.getAll();
                    });
                },
                clear: function () {
                    return $indexedDB.openStore('Tasks', function (store) {
                        return store.clear();
                    });
                }
            }
        };
    }]);

}());
